/*
 * The current case's visa, read from case data (never from the URL). The case
 * record is canonical; the individual's `visaType` covers cases whose case
 * document has not loaded or has no visa yet. `VISAVALUE.EMPTY` when unknown.
 */
import { useCaseOptional } from "../../contexts/CaseContext";
import { useIndividualOptional } from "../../contexts/IndividualContext";
import { VISAVALUE } from "../../types/visa.type";

const VISA_VALUES = new Set<string>(Object.values(VISAVALUE));

/** Coerce a stored visa string into the enum, or EMPTY when it is not one. */
export const asVisaValue = (v: unknown): VISAVALUE =>
  typeof v === "string" && VISA_VALUES.has(v)
    ? (v as VISAVALUE)
    : VISAVALUE.EMPTY;

export const useCaseVisa = (): VISAVALUE => {
  const caseCtx = useCaseOptional();
  const individualCtx = useIndividualOptional();
  const fromCase = asVisaValue(caseCtx?.case?.visa);
  if (fromCase !== VISAVALUE.EMPTY) return fromCase;
  return asVisaValue(individualCtx?.individual?.visaType);
};
